import React from 'react';
import StoreComponent from './store/index';
import SEO from '../components/seo';

const Store = () => {
  return (
    <>
      <SEO
        title="Stores"
        description="Browse all stores"
      />
      <StoreComponent />
    </>
  );
};

export default Store;